var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('img',{attrs:{"src":require("../assets/img/pay.jpg")}})])
}]

export { render, staticRenderFns }